import { AgentStateModule } from '@/store/modules/agent/types';

const state = (): AgentStateModule => ({
    agentsContainer: {},
});

export default state;
